import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { ChevronLeft } from 'lucide-react';
import { toast } from 'sonner';
import { clearPendingVenueReferralData, storePendingVenueReferralData } from '../utils/deepLinkHandler';
import { useBackTarget } from '../hooks/useBackTarget';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const font = "'Inria Serif', serif";

export default function VenueInviteEntryPage() {
  const navigate = useNavigate();
  const goBack = useBackTarget();
  const { referralId } = useParams();
  const [loading, setLoading] = useState(true);
  const [referral, setReferral] = useState(null);

  useEffect(() => {
    const loadReferral = async () => {
      try {
        const response = await axios.get(`${API}/venue-referrals/${referralId}/landing`);
        setReferral(response.data);
        storePendingVenueReferralData(response.data);

        const token = localStorage.getItem('token');
        if (token) {
          navigate('/venue/intro', { replace: true });
          return;
        }
      } catch (error) {
        toast.error(error.response?.data?.detail || 'Venue invite not found');
      } finally {
        setLoading(false);
      }
    };

    if (referralId) {
      loadReferral();
    }
  }, [navigate, referralId]);

  return (
    <div className="app-shell premium-page" data-testid="venue-invite-entry-page" style={{ backgroundColor: 'var(--app-bg)' }}>
      <button onClick={goBack} data-testid="venue-invite-entry-back-button" style={{ position: 'absolute', top: 'calc(env(safe-area-inset-top, 0px) + 20px)', left: 20, background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}>
        <ChevronLeft size={28} color="var(--text)" strokeWidth={1.5} />
      </button>

      <img src="/allure-logo.png" alt="Allure" style={{ width: 146, height: 130, objectFit: 'contain', marginTop: 60 }} />

      <div style={{ width: '100%', maxWidth: 340, marginTop: 30, display: 'grid', gap: 18 }}>
        <div className="premium-card" style={{ width: '100%', padding: '22px 20px', textAlign: 'center' }}>
          <p style={{ fontFamily: font, fontSize: 24, fontWeight: 700, color: 'var(--text)', margin: 0, lineHeight: 1.08 }}>You’ve been invited to join Allure</p>
          <p style={{ fontFamily: font, fontSize: 18, color: 'var(--text)', margin: '14px 0 0', lineHeight: 1.28 }}>
            {loading ? 'Loading invite…' : `${referral?.venue_name || 'A venue'} has been recommended to join Allure.`}
          </p>
          {referral?.referrer_name ? <p style={{ fontFamily: font, fontSize: 15, color: 'var(--text-2)', margin: '12px 0 0', lineHeight: 1.2 }}>Shared by {referral.referrer_name}</p> : null}
        </div>

        <button type="button" onClick={() => navigate('/register')} data-testid="venue-invite-entry-register-button" className="premium-pill-button" style={{ width: '100%', padding: '14px 0', fontFamily: font, fontSize: 20, cursor: 'pointer' }}>
          Create Account
        </button>

        <button type="button" onClick={() => navigate('/login')} data-testid="venue-invite-entry-login-button" style={{ background: 'none', border: 'none', cursor: 'pointer', fontFamily: font, fontSize: 18, color: 'var(--text-2)', textDecoration: 'underline', textUnderlineOffset: 4 }}>
          Already have an account?
        </button>

        <button type="button" onClick={() => { clearPendingVenueReferralData(); navigate('/welcome'); }} data-testid="venue-invite-entry-later-button" style={{ background: 'none', border: 'none', cursor: 'pointer', fontFamily: font, fontSize: 16, color: 'var(--text-2)' }}>
          Not now
        </button>
      </div>
    </div>
  );
}